module.exports = __webpack_public_path__ + "img/good-session-8.1fd90aac.png";